import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTrackOrderIngressWidgetStyles = isLargeScreen => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    },
    subContainer: {
      flex: 1,
      marginRight: spacing.SPACING_14
    },
    subHeading: {
      marginTop: spacing.SPACING_2
    },
    trackImage: {
      flexShrink: 0,
      height: isLargeScreen ? spacing.SPACING_96 : spacing.SPACING_56,
      width: isLargeScreen ? spacing.SPACING_96 : spacing.SPACING_56
    },
    ctaButton: {
      marginTop: spacing.SPACING_14
    }
  });
};